import React, { ChangeEvent } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
}

export const SelectCardToolbox = React.memo(({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds, (node) => ({
    props: node?.data.props || {},
  }));

  const onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setProps({ value });
  };

  return (
    <Section name="Multi-select Card">
      <ValueBox label="Name">
        <ValueInput
          value={props.value}
          name="name-label-value"
          onChange={onChangeName}
          placeholder="Name"
        />
      </ValueBox>
    </Section>
  );
});
